import { Dialog, DialogContent, DialogActions, DialogTitle, CardMedia, Button, Grid2, Box, Typography, IconButton } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useState, useMemo, useEffect } from 'react';
import MyNumberInput from '../../../components/inputs/MyNumberInput';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';
import { useDropzone } from "react-dropzone"
import imgPDF from "../../../assets/img/PDF_icon.png"

// ICONOS
import { Tab, Tabs } from '@mui/material';
import Cookies from 'js-cookie';
import DeleteIcon from "@mui/icons-material/Delete";

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#1f2a40',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#1f2a40',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};
  
  const acceptStyle = {
    borderColor: '#00e676'
};
  
  const rejectStyle = {
    borderColor: '#ff1744'
};

function SubirModal({ open, onClose, refresh, rowData, onUpdate }) {

    const [datos, setdatos] = useState([]);

    const [acceptedFiles, setAcceptedFiles] = useState([]); 

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject,
        fileRejections
    } = useDropzone({
        //accept: '.pdf', // Aceptar solo archivos PDF
        accept: {'application/pdf': []},
        maxFiles: 1,
        onDrop: (acceptedFiles, rejectedFiles) => {
            setAcceptedFiles(acceptedFiles);  // Guardar los archivos aceptados en el estado
            // Filtrar archivos aceptados manualmente
            const validFiles = acceptedFiles.filter(file => file.name.toLowerCase().endsWith('.pdf'));
    
            if (validFiles.length > 0) {
                setdatos(validFiles); // Guardamos solo archivos PDF
            } else {
                Swal.fire({
                    icon: 'error',
                    title: "¡Solo se permiten archivos PDF!",
                    target: document.getElementById('dialog1')
                });
            }
    
            // Si el archivo es rechazado por alguna razón, también se puede manejar aquí
            if (rejectedFiles.length > 0) {
                Swal.fire({
                    icon: 'error',
                    title: "¡Archivo no permitido!",
                    text: rejectedFiles[0].errors[0].message,
                    target: document.getElementById('dialog1')
                });
            }
        },
        onDropRejected: (fileRejections) => {
            // Aquí puedes manejar archivos que se rechazan debido al tipo o tamaño
            console.log('Archivos rechazados:', fileRejections);
        }
    });

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    const formatDate = (date) => {
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };
    
        const formattedDate = new Date(date).toLocaleDateString('en-GB', options);

        const [day, month, year] = formattedDate.split('/');
        return `${year}-${month}-${day}`;
    };

    const initialValues = {
        unidad: rowData?.asset || '',
        odometro: rowData?.truck_odometer || '',
        distancia: '',
        diesel: '',
        rendimiento: '',
        photo: null,
        usuario: Cookies.get('ebt_nombre')
    };

    const validationSchema = Yup.object().shape({
        distancia: Yup.number().when([], {
            is: () => value === 1,
            then: schema => schema.required('Distancia requerida'),
            otherwise: schema => schema.notRequired(),
        }),
        diesel: Yup.number().when([], {
            is: () => value === 1,
            then: schema => schema.required('La cantidad de diésel es requerida'),
            otherwise: schema => schema.notRequired(),
        }),
        rendimiento: Yup.number().when([], {
            is: () => value === 1,
            then: schema => schema.required('Rendimiento requerido'),
            otherwise: schema => schema.notRequired(),
        }),
/*         photo: Yup.mixed().when([], {
            is: () => value === 1,
            then: schema => schema.required('Se requiere la foto'),
            otherwise: schema => schema.notRequired(),
        }), */
    });

    useEffect(() => {
        if (open) 
        {
            setAcceptedFiles([]);  
        }
        else
        {
            setdatos([]);  
        }
    }, [open]);  

    const handleSubmit = async (values) => 
    {
        if(value === 0)
        {
            if (datos.length !== 0) 
            {
                const formData = new FormData();
                formData.append('file', datos[0]); 
        
                formData.append('unidad', values.unidad);
                formData.append('usuario', values.usuario);

                formData.append('manual', 'false');
        
                Swal.fire({
                    icon: 'info',
                    title: "Cargando...",
                    allowOutsideClick: false,
                    showConfirmButton: false, 
                    target: document.getElementById('dialog1')
                });
        
                try 
                {
                    let response;
        
                    response = await myApi.post(`/fuel_report/crearRegistro3/${rowData?.id}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });

                    //console.log("Cargado", response.data);

                    if (response.data.success) {
                        onUpdate(response.data.data);
                        Swal.fire({
                            icon: 'success',
                            title: "¡PDF Subido!",
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al subir el PDF',
                        });
                    }
                    
                    onClose();
        
                } 
                catch (error) 
                {
                    console.log("Ocurrió un error:", error);
                    Swal.close();
                    Swal.fire({
                        icon: 'error',
                        title: "¡Ocurrió un error!",
                        target: document.getElementById('dialog1')
                    });
                } finally 
                {
                    setdatos([]);
                }
            } 
            else 
            {
                Swal.fire({
                    icon: 'error',
                    title: "¡Seleccione un archivo!",
                    target: document.getElementById('dialog1')
                });
            }
        }
        else if(value === 1)
        {
            //if (!values.distancia || !values.diesel || !values.rendimiento || !values.photo) 
            if (!values.distancia || !values.diesel || !values.rendimiento) 
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Completa todos los campos manuales',
                    target: document.getElementById('dialog1')
                });
                return;
            }

            try
            {
                const formData = new FormData();

                formData.append('unidad', values.unidad);
                formData.append('odometro', values.odometro);
                formData.append('usuario', values.usuario);

                formData.append('distancia', values.distancia);
                formData.append('diesel', values.diesel);
                formData.append('rendimiento', values.rendimiento);

                formData.append('file', values.photo);

                formData.append('manual', 'true');
        
                Swal.fire({
                    icon: 'info',
                    title: "Cargando...",
                    allowOutsideClick: false,
                    showConfirmButton: false, 
                    target: document.getElementById('dialog1')
                });
        
                let response;
    
                response = await myApi.post(`/fuel_report/crearRegistro3/${rowData?.id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                //console.log("Cargado", response.data);

                if (response.data.success) {
                    onUpdate(response.data.data);
                    Swal.fire({
                        icon: 'success',
                        title: "¡Información Subida!",
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al subir la info.',
                    });
                }
                onClose();
    
            } 
            catch (error) 
            {
                console.log("Ocurrió un error:", error);
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: "¡Ocurrió un error!",
                    target: document.getElementById('dialog1')
                });
            } 
            finally 
            {
                setdatos([]);
            }
        }
    };

    return (
        <Dialog id="dialog1" open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Subir Info</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ handleSubmit, errors, touched, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
                            <Grid2 size={{ xs: 12, sm: 12 }}>
                                {/* TABS */}
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs 
                                        value={value}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        onChange={handleChange}
                                        aria-label="tabs"
                                        variant='fullWidth'
                                        centered
                                        style={{ minHeight: 32, padding: 0 }}>
                                        {/* Crea las pestañas utilizando el componente Tab */}
                                            <Tab label="PDF"/>
                                            <Tab label="Manual"/>
                                    </Tabs>
                                </Box>
                            </Grid2>
                            
                            <Grid2 container spacing={2} style={{ flexGrow: 1 }}>
                                {value === 0 && 
                                    <Grid2 size={{ xs: 12, sm: 12 }}>
                                        <Box m="20px 0 0 0"
                                            height="25vh"
                                            width="100%">
                                            <div {...getRootProps({style: {
                                                    ...style,
                                                    borderColor: (touched.file && errors.file) ? 'red' : style.borderColor,  
                                                    color: (touched.file && errors.file) ? 'red' : style.color,  
                                                },})}>
                                                <input {...getInputProps()}
                                                    onDrop={(acceptedFiles) => {
                                                        setFieldValue("file", acceptedFiles[0] ? [acceptedFiles[0]] : []); 
                                                    }}
                                                />
                                                <p>Arrastre el archivo aquí o de clic para seleccionar el archivo.</p>
                                            </div>
                                            {/* Mostrar error de validación de archivo */}
                                            {errors.file && touched.file && (
                                                <div style={{ color: 'red', fontSize: '12px' }}>
                                                    {errors.file}
                                                </div>
                                            )}
                                            <aside style={{ marginTop: 'auto' }}> 
                                            <h4>
                                            <p>Archivo Cargado:</p>
                                            </h4>  
                                            <ul id="listaArchivo">
                                                {/* Filtrar y mostrar solo archivos PDF */}
                                                {acceptedFiles
                                                    .filter(file => file.name.toLowerCase().endsWith('.pdf'))  // Asegurarse de que es un archivo PDF
                                                    .map(file => (
                                                        <li key={file.path}>
                                                            <Typography>
                                                                <img src={imgPDF} style={{ height: '20px' }} alt="PDF Icon" /> {file.path} - {file.size} bytes
                                                            </Typography>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                            </aside>                 
                                        </Box>  
                                    </Grid2>     
                                }  
                                {value === 1 && 
                                (
                                    <>
                                    <Grid2 size={{ xs: 12, sm: 4 }} mt={2}>
                                        <MyNumberInput
                                            name="distancia"
                                            label="Distancia (mi)"
                                        />
                                    </Grid2> 
                                    <Grid2 size={{ xs: 12, sm: 4 }} mt={2}>
                                        <MyNumberInput
                                            name="diesel"
                                            label="Diésel Consumido (gal)"
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, sm: 4 }} mt={2}>
                                        <MyNumberInput
                                            name="rendimiento"
                                            label="Rendimiento (mpg)"
                                        />
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, sm: 12 }} mt={2}>
                                        <input
                                            accept="image/*"
                                            type="file"
                                            id="upload-photo"
                                            name="photo"
                                            style={{ display: 'none' }}
                                            onChange={(event) => {
                                                setFieldValue("photo", event.currentTarget.files[0]);
                                            }}
                                        />
{/*                                         <label htmlFor="upload-photo">
                                            <Button variant="outlined" component="span">
                                                Subir Foto
                                            </Button>
                                        </label> */}
                                        {errors.photo && touched.photo && (
                                            <div style={{ color: 'red', fontSize: '12px' }}>
                                                {errors.photo}
                                            </div>
                                        )}
                                        {values.photo && (
                                            <Box mt={2} position="relative" width={150}>
                                            <CardMedia
                                                component="img"
                                                height="150"
                                                image={URL.createObjectURL(values.photo)}
                                                alt="Foto seleccionada"
                                                sx={{
                                                borderRadius: 2,
                                                objectFit: "cover",
                                                width: "150px",
                                                height: "150px",
                                                }}
                                            />
                                            <IconButton
                                                onClick={() => setFieldValue("photo", null)}
                                                sx={{
                                                position: "absolute",
                                                top: 0,
                                                right: 0,
                                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                                }}
                                            >
                                                <DeleteIcon color="error" />
                                            </IconButton>
                                            </Box>
                                        )}
                                    </Grid2>
                                    </>
                                )}        
                                <DialogActions style={{ justifyContent: 'flex-end', marginTop: 'auto' }}>
                                    <Button type="submit" variant="contained" color="primary">
                                        Subir
                                    </Button>
                                    <Button onClick={onClose}>Cancelar</Button>
                                </DialogActions>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default SubirModal